import React, { Component } from 'react';
//import ReactTable from "react-table";
import "react-table/react-table.css";
import { List, Icon, Segment, Input, Button, Label, Dimmer, Loader } from 'semantic-ui-react';
import { map, addIndex } from 'ramda';
import { generate } from 'shortid';
import { updateInPath } from '../../../../common/utils';
import { UpdateScheduleItemResult, UpdateScheduleItemRobot } from './TeamCell.graphql.js';
import { setItem } from '../../../common/utils';

const ixMap = addIndex(map);

class RobotInput extends Component {
  constructor(props) {
    super();

    const { robotNumber } = props.data;
    
    this.state = {
      originalResult: robotNumber,
      newResult: robotNumber,
      saving: false
    };
  }

  handleResultReset = () => {
    this.setState(s => updateInPath(s, 'newResult', this.state.originalResult));
  };

  handleResultSave = async () => {
    const result = this.state.newResult;
    this.setState(s => updateInPath(s, 'saving', true));

    console.log(result);

    const response = await setItem(UpdateScheduleItemRobot, {
      id: this.props.data.id,
      teamId: this.props.data.teamId,
      robotNumber: result + ''
    });

    if (response.updateScheduleItemRobot) {
      this.setState(s => updateInPath(s, 'originalResult', result));
      this.setState(s => updateInPath(s, 'saving', false));
    }
  };

  handleResultChange = (e, { value }) => {
    this.setState(s => updateInPath(s, 'newResult', value));
  };

  render() {
    const { originalResult: o, newResult: n, saving } = this.state;
    
    return (
      <div>
        <Dimmer active={saving} inverted>
          <Loader inverted inline='centered'/>
        </Dimmer>
        <Input
          size='small'
          type='text'
          placeholder='Robot number..'
          onChange={this.handleResultChange}
          value={this.state.newResult}>
          <Label>Robot number</Label>
          <input />
          &nbsp;
          <Button
            size='mini'
            disabled={o === n}
            onClick={this.handleResultReset}>
            Cancel
          </Button>
          &nbsp;
          <Button
            size='mini'
            disabled={o === n}
            onClick={this.handleResultSave}
            positive>
            Save
          </Button>
        </Input>
      </div>
    );
  }
}

class ResultInput extends Component {
  constructor(props) {
    super();

    const { result, robotNumber } = props.data;
    
    this.state = {
      robotNumber: robotNumber,
      seconds: result === null ? '': result/1000,
      originalResult: result === null ? '': result,
      newResult: result === null ? '': result,
      saving: false
    };
  }

  handleResultReset = () => {
    const result = this.state.originalResult;
    this.setState(s => updateInPath(s, 'newResult', result === null ? '': result));
    this.setState(s => updateInPath(s, 'seconds', result === null ? '': result/1000));
  };

  handleResultSave = async () => {
    const result = this.state.newResult;
    this.setState(s => updateInPath(s, 'saving', true));

    const response = await setItem(UpdateScheduleItemResult, {
      id: this.props.data.id,
      teamId: this.props.data.teamId,
      result: result
    });

    if (response.updateScheduleItemResult) {
      this.setState(s => updateInPath(s, 'originalResult', result));
      this.setState(s => updateInPath(s, 'saving', false));
    }
  };

  handleResultChange = (e, { value }) => {
    if (value === '') {
      this.setState(s => updateInPath(s, 'newResult', 0));
      this.setState(s => updateInPath(s, 'seconds', 0));
      // TODO == -> ===
      // Test and fix!
    } else if (parseInt(value, 10) == value) {
      this.setState(s => updateInPath(s, 'newResult', parseInt(value, 10)));
      this.setState(s => updateInPath(s, 'seconds', value/1000));
    }
  };

  handleSecondsConversion = (e, { value }) => {
    this.setState(s => updateInPath(s, 'seconds', value));
    if (value && !isNaN(value * 1000)) {
      this.setState(s => updateInPath(s, 'newResult', value * 1000));
    }
  };

  render() {
    const { originalResult: o, newResult: n, saving } = this.state;
    
    return (
      <div>
        <Dimmer active={saving} inverted>
          <Loader inverted inline='centered'/>
        </Dimmer>
        {this.props.resultUnit === 'MILLISECONDS' &&
         <Input
           size='small'
           type='text'
           placeholder='Type seconds here'
           onChange={this.handleSecondsConversion}
           value={this.state.seconds}>
           <Label>SECONDS</Label>
           <input />
         </Input>}
        
        <Input
          size='small'
          type='text'
          placeholder='Result...'
          onChange={this.handleResultChange}
          value={this.state.newResult}>
          <Label>{this.props.resultUnit}</Label>
          <input />
          &nbsp;
          <Button
            size='mini'
            disabled={o === n}
            onClick={this.handleResultReset}>
            Cancel
          </Button>
          &nbsp;
          <Button
            size='mini'
            disabled={o === n}
            onClick={this.handleResultSave}
            positive>
            Save
          </Button>
        </Input>
      </div>
    );
  }
};

const TeamItem = (props) => {
  const { data, editable } = props,
        tc = data.technicalControl || {};

  return (
    <List.Item>
      {tc.status === 'PASSED' && <Icon color='green' name='check' />}
      {tc.status === 'FAILED' && <Icon color='red' name='ban' />}
      {(tc.status === 'NA' || !tc.status) && <Icon color='grey' name='minus' />}
      <List.Content>
        <List.Header>
          {data.robotNumber} ({data.robotName})
        </List.Header>
        <List.Description>
          Team: {data.name},
          Technical Control: {tc.status}
          {tc.comments && <span> ({tc.comments})</span> }
        </List.Description>
        {editable &&
         <List.Description>
           {data.teamId === 'NULL' && <RobotInput data={data} /> } &nbsp;
           {<ResultInput data={data} resultUnit={data.resultUnit}/> }
         </List.Description>}
      </List.Content>
    </List.Item>
  );
};

const TeamCell = (props) => {
  const teams = props.data.teams;

  return (
    <Segment basic>
      <List ordered relaxed>
        {ixMap(team =>
               <TeamItem
                 key={generate()}
                 data={team}
                 editable={props.editable}/>, teams)}
      </List>
    </Segment>
  );
};

export default TeamCell;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/TeamCell.js